var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"6","width":"11","height":"1","fill":"black","className":"fill-el","key":0}),React.createElement("path",{"d":"M5.93656 1L1 6.5L5.93656 12","stroke":"black","className":"stroke-el","key":1})]);
}

ArrowLeft.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
